<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="mappedBookmarks(role)" />
  </div>
</template>

<script>
import navMenuItems from '@/navigation/horizontal'
import { mapGetters } from 'vuex'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

export default {
  components: {
    HorizontalNavMenuItems,
  },
  setup() {
    return {
      navMenuItems,
    }
  },
  computed: {
    ...mapGetters({
      user: 'oidc/oidcUser',
      role: 'users/getUserRole',
    }),
  },
  methods: {
    mappedBookmarks(role) {
      const auth = {
        'LeRefuge.Administrateur': ['Statistiques', 'Utilisateurs', 'Mobile'],
        'LeRefuge.Coordinateur': ['Planning', 'Jeunes', 'Répondeur', 'Statistiques', 'Utilisateurs', 'Utilisateurs bloqués', 'Demandes d\'hébergement'],
        'LeRefuge.Ecoutant': ['Planning', 'Jeunes', 'Répondeur', 'Utilisateurs bloqués', 'Demandes d\'hébergement'],
        'LeRefuge.SuperAdmin': ['Planning', 'Jeunes', 'Répondeur', 'Statistiques', 'Utilisateurs', 'Utilisateurs bloqués', 'Mobile', 'Demandes d\'hébergement'],
      }
      return this.navMenuItems.filter(bookmark => auth[role]?.includes(bookmark.title))
    },
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
